import request from '@/utils/request'

export function fetchList(params) {
    return request({
        url: '/api/post/list',
        method: 'get',
        params: params
    })
}

export function fetchPost(params) {
    let postId = params.id;
    let urlPath = "/api/post/" + postId;
    return request({
        url: urlPath,
        method: 'get',
        params: {}
    })
}

export function addClickNum(params) {
    return request({
        url: "/api/post/click",
        method: 'post',
        data: params
    })
}

export function fetchFocus() {
    return request({
        url: '/api/focus/list',
        method: 'get',
        params: {}
    })
}

export function fetchCategory() {
    return request({
        url: '/api/category',
        method: 'get',
        params: {}
    })
}

export function fetchFriend() {
    return request({
        url: '/api/friend',
        method: 'get',
        params: {}
    })
}

export function fetchSocial() {
    return request({
        url: '/api/social',
        method: 'get',
        params: {}
    });
}

export function fetchSiteInfo() {
    return request({
        url: '/api/site',
        method: 'get',
        params: {}
    })
}

export function fetchComment() {
    return request({
        url: '/api/comment',
        method: 'get',
        params: {}
    })
}

